module.exports = __webpack_public_path__ + "static/media/sans.6762c6fb.ogg";